import React from "react";
import "./Footer.css";
import Form from "./form/Form";

function Footer() {
  return (
    <footer>
      <div className="top">
        <div className="wrapper">
          <a href="/home" className="logo">
            <svg xmlns="http://www.w3.org/2000/svg" width="95" height="38">
              <g fill="none" fillRule="evenodd">
                <path
                  fill="#010101"
                  fillule="nonzero"
                  d="M110.804 13.872c-.469-.094-.937-.188-1.312-.564-.281-.281-.562-.657-.562-1.126 0-.188-.094-.282-.094-.47-.187.376-.562.845-.843 1.127-.75.939-1.5 1.502-2.905 1.971-1.03.282-1.968.188-2.155-.938-.094-.47 0-.94.094-1.409.374-1.408 1.499-2.629 1.967-4.037.094-.281.281-.939.188-1.314 0-.094-.094-.188-.188-.188-.093-.094-.187-.094-.187-.094-.469.094-.937.751-1.312 1.127-.375.47-.75.939-.937 1.596l-2.717 6.102-2.249.47-.937.188-.843.187c-.937.376-1.874.376-2.436-.563-1.218 1.596-2.811 2.16-4.873 1.408-1.03-.375-1.311-1.408-1.311-2.44v.093c-.656 1.033-1.312 2.066-1.968 2.723-.656.563-1.593.939-2.062 1.033-.468.093-.937.093-1.311-.188-.281-.188-.563-.657-.656-1.22-.094-.282-.094-.658 0-1.127l-.188.187c-.562.658-1.218 1.315-1.874 1.972-.655.563-1.405 1.127-2.248 1.596-.281.188-.656.282-1.031.47-.375.187-.656.187-1.03.281-.282-.094-.47-.094-.75-.094h-.656c-1.5-.188-2.249-1.502-2.155-2.816-1.125 1.502-2.436 2.816-4.217 3.755-.28.188-.656.282-1.03.47-.375.187-.656.187-1.031.281-.187.094-.375.094-.562.094h-.656c-1.218-.094-1.874-.939-2.062-1.972-.562 1.127-1.686 2.254-2.81 2.723-1.031.282-2.156.282-2.53-.657-1.78 2.065-5.248 2.723-6.09.563-2.343 1.878-6.935 3.756-10.027 3.098-2.436 1.972-6.184 2.817-7.87.845-.562-.563-.469-1.502.093-2.065.844-1.033 1.968-.657 2.999-.563 1.218.094 2.342 0 3.56 0 3.748-5.915 4.966-20.655 13.774-23.19 3.373-.939 6.653 1.22 5.997 5.07-.844 4.412-6.934 9.2-11.338 10.421-2.155.563.375-.845 1.125-1.314 1.499-.94 2.81-2.066 4.029-3.474 1.78-1.972 5.34-7.793 3.467-9.482-1.687-1.503-3.936 2.065-5.154 4.224-2.81 4.976-6.465 13.52-9.557 17.65 1.78-.093 4.123-.656 6.184-1.314 1.874-.657 2.249-1.032 3.092-2.722.094-.188.187-.47.281-.564.843-1.596 1.687-3.098 2.343-4.694.937-.188 1.967-.47 2.904-.563-1.03 1.502-1.967 3.098-2.717 4.788-.281.657-.656 1.408-.843 2.065-.75 2.348 1.499 1.972 2.342.658 1.593-2.347 2.624-5.446 3.842-7.887l3.092-.563c-.562.845-1.218 1.972-1.687 2.817-.562 1.314-1.03 2.347-1.593 3.661-.187.563-.562 2.066.469 1.972.187-.094.562-.188.75-.376.28-.188.562-.563.843-.939.187-.375.562-.939.75-1.69.093-.187.187-.47.187-.657 0-.094.093-.094.093-.188.375-.938.937-1.877 1.687-2.722 1.03-1.409 4.966-4.6 7.121-2.723.937.845.281 2.253-.187 2.91-.375.564-1.5 1.972-1.312.282.094-.657.094-1.22.094-1.878 0-1.22-1.125-1.126-1.78-.375-.375.375-.657.845-.938 1.314-.562 1.033-4.31 6.948-.374 6.29.562-.093.937-.281 1.311-.563.469-.281.937-.563 1.312-.939 1.218-1.032 2.717-3.098 3.842-4.788.28-.47.562-.939.937-1.314 1.03-1.408 4.966-4.6 7.12-2.723.938.845.282 2.253-.186 2.91-.375.564-1.5 1.972-1.312.282.093-.657.093-1.22.093-1.877 0-1.22-1.124-1.127-1.78-.376-.375.376-.656.845-.937 1.314-.562 1.033-4.31 6.948-.375 6.29.469-.093.937-.28 1.312-.563.469-.281.937-.563 1.312-.938 1.5-1.315 2.342-2.441 3.56-4.225.656-1.22 1.687-2.347 1.968-4.037l3.092-.47c.188.657-.75 1.972-1.03 2.535-.469.657-2.811 4.131-1.874 4.788.093.094.187.188.468.094.937-.188 1.312-1.126 1.687-1.784.562-.938 1.03-1.502 1.405-2.159 1.218-2.347 3.935-5.915 6.84-4.6l.562.281.375-.657 2.624-.47s-2.811 6.385-2.905 7.042c-.094 1.127.562 1.972 1.593 1.22l.187-.187c1.312-2.723 2.343-5.258 3.373-8.45l3.093-.563c-.094.281 0 .563.093.845l.469-.47c.187-.187.468-.375.75-.563.187-.094.28-.188.468-.188.187-.094.28-.094.468-.187.562-.094.937-.094 1.406.187.468.188.75.564.937.94v.281c.093.47 0 .939-.188 1.314-.187.563-.374.939-.562 1.502-.094.188-.187.282-.187.47-.094.188-.188.281-.188.47-.28.563-.562 1.032-.843 1.69-.562 1.126-.281 1.877.656.844 1.218-1.314 2.155-3.098 2.998-4.319.375-.657.844-1.314 1.312-1.971.75-.94 1.593-1.69 2.53-2.347.281-.188.656-.376 1.03-.564.188-.375.563-.47.844-.47.281-.093.656-.093.937-.093s.562.094.937.188c.281.188.562.281.75.563.187.282.28.563.374.939.094.47.094.939 0 1.314-.093.564-.28 1.033-.468 1.503-.469 1.126-1.125 2.065-1.874 3.098-.75.939-1.687 1.69-2.717 2.347-.282.188-.563.282-.844.375-.28.094-.562.188-.843.188-.187 0-.375.094-.562.094-.188-.282-.375-.375-.562-.375zM45.683 38l3.467-7.792c11.806-7.324 30.546-7.042 46.1-9.295 4.216-.563 8.901-1.22 12.93-2.723 2.436-.939 4.685-2.065 6.653-3.755 1.686-1.315 2.623-2.723 3.841-4.319.844-1.127.937-.939.188.563-.844 1.596-1.687 3.099-2.811 4.6-1.968 2.536-4.779 4.601-8.246 6.103-3.841 1.69-8.526 2.63-12.836 3.38C80.82 27.297 61.987 28.612 45.683 38zM126.17 5.985c.937 1.315.937 3.286-.187 4.6-1.03 1.127-2.624 1.878-4.123 1.784-.281 0-.656-.094-.937-.187-1.312-.564-1.124-.94-.281-1.878.187-.188.468-.563.562-.188.562 1.033 1.312 2.066 2.436.751.563-.75.281-1.69-.093-2.347-.469-.939-1.312-1.408-1.874-2.253-.375-.563-.563-1.315-.094-1.972.562-1.032 1.5-1.971 2.249-2.722.562-.564 1.124-.564 1.967-.752.094 0 .656-.187.937-.187h.188c.187 0 0 .187-.094.281-2.061 1.878-2.436 2.16-.656 5.07zM119.518.07c-.094-.093-.188-.093-.188 0-.187.47-.375.845-.843 1.22-.094.095-.094.095 0 .189 1.124.75 1.312 1.69 1.5 2.91 0 .188.093.282.187.094.562-1.596.187-3.098-.656-4.413zM85.692 4.483c-.937.188-1.593 1.033-1.405 1.972.187.938 1.03 1.596 1.968 1.408.937-.188 1.592-1.033 1.405-1.972-.094-1.032-1.03-1.596-1.968-1.408zm8.527 5.07c.281-1.408-.562-1.69-1.593-.657-1.312 1.314-2.342 3.473-2.717 5.257-.469 2.16.75 2.629 1.967.939l.282-.563.28-.564c.75-1.502 1.406-2.91 1.78-4.412zm20.801.563c.094-.188.187-.282.187-.47.282-.563.563-1.126.75-1.69.187-.563.469-1.126.562-1.69.281-1.595-.187-3.003-1.686-1.314-.469.564-.844 1.127-1.218 1.69-.469.845-3.092 6.29-.937 5.727.374-.094.655-.281.937-.563.562-.375 1.03-1.127 1.405-1.69z"
                  transform="translate(-32)"
                ></path>
              </g>
            </svg>
          </a>
          <div className="lines">
            <div className="circle white">
              <div className="dot"></div>
            </div>
          </div>
          <div className="navigation">
            <div className="left">
              <div className="column">
                <a href="/historia" className="link-dot">
                  Historia
                </a>
                <a href="/productos?c=icepops" className="link-dot">
                  IcePops
                </a>
                <a href="/productos?c=icecreams" className="link-dot">
                  Ice Cream
                </a>
              </div>
              <div className="column">
                <a href="/locales" className="link-dot">
                  Locales
                </a>
                <a href="/inspiration-lab" className="link-dot">
                  Inspiration Lab
                </a>
                <a href="/party-service" className="link-dot">
                  Party Service
                </a>
              </div>
              <div className="column">
                <a href="/franquicias" className="link-dot">
                  Franquicias
                </a>
                <a href="/contacto" className="link-dot">
                  Contacto
                </a>
                <a
                  href="https://tienda.luccianos.net/"
                  target="_blank"
                  className="link-dot"
                >
                  Tienda
                </a>
                <a href="/novedades" className="link-dot">
                  Novedades
                </a>
              </div>
            </div>
            <div className="right">
              <a href="/productos?c=icepops">
                <p className="big">Seguí conociéndonos</p>
                <h2>IcePops</h2>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Form */}
      <div className="bottom">
        <div className="wrapper">
          <Form></Form>

          {/* Social */}
          <div className="social">
            <div className="inner">
              <a
                href="https://www.instagram.com/luccianos_/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i> @luccianos_
              </a>
              <div className="circle white">
                <div className="dot"></div>
              </div>
              <a
                href="https://www.facebook.com/luccianos"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i> /luccianos
              </a>
              <div className="circle white">
                <div className="dot"></div>
              </div>
              <a
                href="https://www.tiktok.com/@luccianos_"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-tiktok"></i> @luccianos_
              </a>
            </div>
          </div>

          <div className="copy">
            <p>
              © 2023 Lucciano´s. Todos los derechos reservados.
              <a href="/terminos-y-condiciones">Términos y condiciones.</a>
              <a href="/politicas-de-privacidad">Políticas de privacidad.</a>
            </p>
            <p>
              <a
                href="https://estudionk.com"
                target="_blank"
                rel="noopener noreferrer"
                className="link-dot"
              >
                Realizado por estudio/nk
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
